export default __webpack_public_path__ + "static/media/ea-dropdown.e0eac38f.webp";